import { TextField, MenuItem } from "@mui/material";
import DisplayTextField from "../DisplayTextField";

const MedicationFieldForObjectState = ({ formInfo, Object, handleChange }) => {
  let name = Object.name;
  let Page = Object.Page;

  let Array = [
    {
      Page: Page,
      TextField: "TextFieldForObjectState",
      label: "Name of medication",
      name: name + "prescribed_medication",
      onlyAppearIfValueIs: false,
      onlyAppearIfValueIsNot: false,
      withRegardsTo: false,
    },

    {
      Page: Page,
      TextField: "TextFieldForObjectState",
      label: "Dosage of medication",
      name: name + "prescribed_medication_dosage",
      onlyAppearIfValueIs: false,
      onlyAppearIfValueIsNot: false,
      withRegardsTo: false,
    },
    {
      Page: Page,
      TextField: "TextFieldForObjectState",
      label: "Frequency",
      name: name + "prescribed_medication_frequency",
      onlyAppearIfValueIs: false,
      onlyAppearIfValueIsNot: false,
      withRegardsTo: false,
      AboveText: <p>Frequency (e.g. two times per day, or only when needed)</p>,
    },
    {
      Page: Page,
      TextField: "TextFieldForObjectState",
      label: "Application (e.g. injection/ tablet)",
      name: name + "prescribed_medication_application",
      onlyAppearIfValueIs: false,
      onlyAppearIfValueIsNot: false,
      withRegardsTo: false,
    },
    {
      Page: Page,
      TextField: "TextFieldForObjectState",
      label: "Instructions (e.g. use EpiPen in thigh)",
      name: name + "prescribed_medication_instructions",
      onlyAppearIfValueIs: false,
      onlyAppearIfValueIsNot: false,
      withRegardsTo: false,
    },
    {
      Page: Page,
      TextField: "SelectFieldForObjectState",
      label: "Controlled drug",
      name: name + "prescribed_medication_controlled_drug",
      selectValues: ["Yes", "No"],
      onlyAppearIfValueIs: false,
      onlyAppearIfValueIsNot: false,
      withRegardsTo: false,
      AboveText: (
        <p>
          Is this medication a controlled drug? (please see{" "}
          <a
            href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
            target="_blank"
          >
            <strong>LINK </strong>
          </a>
          here for guidance)
        </p>
      ),
    },
    {
      Page: Page,
      TextField: "SelectFieldForObjectState",
      label: "Bad interactions",
      name: name + "prescribed_medication_interact_badly",
      selectValues: ["Yes", "No"],
      onlyAppearIfValueIs: false,
      onlyAppearIfValueIsNot: false,
      withRegardsTo: false,
      AboveText: (
        <p>
          Does this medicine interact badly, or should not be taken in
          conjunction with, any other medicine
        </p>
      ),
    },
    {
      Page: Page,
      TextField: "TextFieldForObjectState",
      label: "Please specify",
      name: name + "prescribed_medication_interact_badly_specify",
      onlyAppearIfValueIs: ["Yes"],
      onlyAppearIfValueIsNot: false,
      withRegardsTo: name + "prescribed_medication_interact_badly",
    },
    {
      Page: Page,
      TextField: "SelectFieldForObjectState",
      label: "Is there anything else we need to know",
      name: name + "prescribed_medication_anything_else",
      selectValues: ["Yes", "No"],
      onlyAppearIfValueIs: false,
      onlyAppearIfValueIsNot: false,
      withRegardsTo: false,
      AboveText: (
        <p>
          Is there anything else we need to know about this treatment/
          medication
        </p>
      ),
    },
    {
      Page: Page,
      TextField: "TextFieldForObjectState",
      label: "Please specify",
      name: name + "prescribed_medication_anything_else_specify",
      onlyAppearIfValueIs: ["Yes"],
      onlyAppearIfValueIsNot: false,
      withRegardsTo: name + "prescribed_medication_anything_else",
    },
    {
      Page: Page,
      TextField: "SelectFieldForObjectState",
      label: "Any specific aftercare needs",
      name: name + "prescribed_medication_aftercare",
      selectValues: ["Yes", "No"],
      onlyAppearIfValueIs: false,
      onlyAppearIfValueIsNot: false,
      withRegardsTo: false,
      AboveText: (
        <p>
          Are there any specific aftercare needs the student may have? (E.g. are
          there any additional symptoms we should be aware of once the medicine
          has been provided)
        </p>
      ),
    },
    {
      Page: Page,
      TextField: "TextFieldForObjectState",
      label: "Please specify",
      name: name + "prescribed_medication_aftercare_specify",
      onlyAppearIfValueIs: ["Yes"],
      onlyAppearIfValueIsNot: false,
      withRegardsTo: name + "prescribed_medication_aftercare",
    },
  ];

  return (
    <>
      <DisplayTextField
        formInfo={formInfo}
        handleChange={handleChange}
        Object={Array[0]}
      />
      <DisplayTextField
        formInfo={formInfo}
        handleChange={handleChange}
        Object={Array[1]}
      />
      <DisplayTextField
        formInfo={formInfo}
        handleChange={handleChange}
        Object={Array[2]}
      />
      <DisplayTextField
        formInfo={formInfo}
        handleChange={handleChange}
        Object={Array[3]}
      />
      <DisplayTextField
        formInfo={formInfo}
        handleChange={handleChange}
        Object={Array[4]}
      />
      <DisplayTextField
        formInfo={formInfo}
        handleChange={handleChange}
        Object={Array[5]}
      />
      <DisplayTextField
        formInfo={formInfo}
        handleChange={handleChange}
        Object={Array[6]}
      />
      <DisplayTextField
        formInfo={formInfo}
        handleChange={handleChange}
        Object={Array[7]}
      />
      <DisplayTextField
        formInfo={formInfo}
        handleChange={handleChange}
        Object={Array[8]}
      />
      <DisplayTextField
        formInfo={formInfo}
        handleChange={handleChange}
        Object={Array[9]}
      />
      <DisplayTextField
        formInfo={formInfo}
        handleChange={handleChange}
        Object={Array[10]}
      />
      <DisplayTextField
        formInfo={formInfo}
        handleChange={handleChange}
        Object={Array[11]}
      />
    </>
  );
};

export default MedicationFieldForObjectState;
